// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { useEffect, useState } from "react";
import { notify } from "@/shared/utils/notify";
import { Controller, FieldErrorsImpl } from "react-hook-form";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import { InputError } from "./styled";
import styled from "styled-components";

// Estilos personalizados para modernizar ReactQuill
const StyledQuill = styled(ReactQuill)`
  .ql-container {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border-color: #d9d9d9;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    font-size: 14px;
  }
  
  .ql-toolbar {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-color: #d9d9d9;
    background-color: #fafafa;
    border-bottom: 1px solid #f0f0f0;
  }

  .ql-editor {
    min-height: 150px;
    color: rgba(0, 0, 0, 0.85);
  }

  .ql-editor.ql-blank::before {
    color: rgba(0, 0, 0, 0.25);
    font-style: normal;
  }
`;

interface Props {
  width?: string;
  placeHolder: string;
  name: string;
  control: any;
  isUpdating?: boolean;
}

interface PropsContent {
  errors: Partial<FieldErrorsImpl<{
    [x: string]: any;
  }>>;
  name: string;
}

const ErrorComponent = ({errors,name}:PropsContent) =>{
  useEffect(() => {
    if(errors?.[name]?.message){
      notify.error(`${errors?.[name]?.message}`)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors])
  return(
    <>
    {!!errors[name] && (
      <InputError>{errors?.[name]?.message}</InputError>
      )}
      </>
  )
}

const modules = {
  toolbar: [
    [{ 'header': [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{ 'color': [] }, { 'background': [] }],
    ['link', 'clean']
  ],
};

const formats = [
  'header',
  'bold', 'italic', 'underline', 'strike',
  'list', 'bullet',
  'color', 'background',
  'link'
];

export const InputHTML = ({
  width = "100%",
  placeHolder,
  name,
  control,
  isUpdating,
}: Props) => {
  const [loadInfo, setLoadInfo] = useState(false);
  
  // Simular carga para casos de actualización si es necesario
  useEffect(() => {
    if (isUpdating) {
      setTimeout(() => {
        setLoadInfo(true);
      }, 100);
    } else {
      setLoadInfo(true);
    }
  }, [isUpdating]);

  return (
    <Controller
      shouldUnregister
      control={control}
      name={name}
      render={({ field: { onChange, value = "" }, formState: { errors } }) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width,
              flexDirection: "column",
            }}
          >
            {loadInfo && (
              <StyledQuill
                theme="snow"
                value={value}
                onChange={onChange}
                placeholder={placeHolder}
                modules={modules}
                formats={formats}
              />
            )}
            <ErrorComponent errors={errors} name={name}/>
          </div>
        );
      }}
    />
  );
};
